import Card from "components/card";
import { BiSearch } from "react-icons/bi";
import SingleMessage from "./SingleMessage";
import {
  MdChevronLeft,
  MdPerson,
} from "react-icons/md";
import { IoPaperPlane } from "react-icons/io5";
import {
  renderThumbMessages,
  renderTrackMessages,
  renderViewMessages,
} from "components/scrollbar/Scrollbar";
import { Scrollbars } from "react-custom-scrollbars-2";

function SingleChat(props: {
  open: boolean;
  onClose: React.MouseEventHandler<HTMLSpanElement>;
  selectedChat?: any;
  variant?: string;
}) {
  const { open, onClose, selectedChat } = props;

  // Get conversation content based on selected chat
  const getConversation = () => {
    switch (selectedChat?.name) {
      case "Alex Rodriguez (Mentee)":
        return {
          messages: [
            {
              message: "Hi Admin, can you help me find a mentor in data science?",
              time: "08:45 PM",
              sender: "other"
            },
            {
              message: "I'm specifically interested in machine learning and AI applications.",
              time: "08:46 PM", 
              sender: "other"
            },
            {
              message: "Hi Alex! I can definitely help you find a suitable mentor.",
              time: "08:50 PM",
              sender: "me"
            },
            {
              message: "I'll assign you Dr. Sarah Chen who specializes in ML and AI.",
              time: "08:51 PM",
              sender: "me"
            }
          ]
        };
      case "Jennifer Kim (Mentor)":
        return {
          messages: [
            {
              message: "Thank you for approving my mentor application!",
              time: "02:30 PM",
              sender: "other"
            },
            {
              message: "I'm excited to start mentoring students in UX design.",
              time: "02:31 PM",
              sender: "other"
            },
            {
              message: "Congratulations Jennifer! Welcome to our mentor community.",
              time: "02:35 PM",
              sender: "me"
            },
            {
              message: "Your portfolio looks excellent. You'll be a great addition!",
              time: "02:36 PM",
              sender: "me"
            }
          ]
        };
      case "Michael Brown (Mentee)":
        return {
          messages: [
            {
              message: "Hi Admin, I wanted to share some feedback about my mentoring experience.",
              time: "11:15 AM",
              sender: "other"
            },
            {
              message: "My mentor has been incredibly helpful with my career development. The platform makes it easy to track our progress!",
              time: "11:16 AM",
              sender: "other"
            },
            {
              message: "That's wonderful to hear Michael! I'm so glad you're having a positive experience.",
              time: "11:20 AM",
              sender: "me"
            },
            {
              message: "Your feedback helps us improve the platform for everyone. Keep up the great work!",
              time: "11:21 AM",
              sender: "me"
            }
          ]
        };
      default: // Dr. Sarah Chen (Mentor)
        return {
          messages: [
            {
              message: "Thank you for setting up such an amazing platform!",
              time: "05:34 PM",
              sender: "other"
            },
            {
              message: "I've been using the mentoring features and they work great. My mentees are really engaged with the content creation tools you've added.",
              time: "09:00 PM",
              sender: "other"
            },
            {
              message: "The scheduling system makes it so easy to coordinate with my students. Great work!",
              time: "09:01 PM",
              sender: "other"
            },
            {
              message: "Thank you so much Dr. Chen! I'm glad the platform is working well for you.",
              time: "09:05 PM",
              sender: "me"
            },
            {
              message: "It's great to hear the mentees are engaged with the content tools. Keep up the excellent mentoring work!",
              time: "09:06 PM",
              sender: "me"
            }
          ]
        };
    }
  };

  const conversation = getConversation();
  return (
    <div
      className={`duration-175 !fixed left-0 top-[20px] !z-[50] h-[calc(100vh-40px)] w-[calc(100vw-40px)] flex-col !font-dm transition-all md:h-[calc(100vh-40px)] lg:!relative lg:left-[unset] lg:top-[unset] lg:!z-[unset] lg:my-0 lg:flex lg:h-full lg:w-[unset] ${
        open
          ? "translate-x-[20px] lg:translate-x-[0px]"
          : "-translate-x-[120%] lg:translate-x-[0px]"
      }`}
    >
      <Card extra={"w-full h-full p-4 !font-dm"}>
        {/* header */}
        <div className="mb-auto flex  items-center justify-between border-b border-gray-200 pb-3 dark:!border-navy-700">
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center gap-2">
              <div onClick={onClose} className={"block lg:hidden"}>
                <MdChevronLeft className="h-5 w-5 text-gray-500 dark:text-white" />
              </div>
              <div className="h-[50px] w-[50px] rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center">
                <MdPerson className="h-6 w-6 text-gray-600 dark:text-gray-400" />
              </div>
            </div>
            <div>
              <h1 className="font-dm text-[20px] font-bold text-navy-700 dark:text-white">
                {" "}
                {selectedChat?.name || "Dr. Sarah Chen (Mentor)"}
              </h1>
              <div className="flex items-center gap-2">
                <div className={`h-2 w-2 rounded-full ${selectedChat?.active ? 'bg-green-600' : 'bg-gray-400'}`}></div>
                <h4 className="text-base text-navy-700 dark:text-white">
                  {selectedChat?.active ? 'Active' : 'Offline'}
                </h4>
              </div>
            </div>
          </div>
          <div className="flex">
            <p className="flex w-max items-center text-[24px] hover:cursor-pointer">
              <BiSearch />
            </p>
          </div>
        </div>
        {/* message content */}
        <div className="relative h-[calc(100%-70px)] pt-2">
          <div className="flex h-[calc(100%-74px)] w-full">
            <Scrollbars
              renderTrackVertical={renderTrackMessages}
              renderThumbVertical={renderThumbMessages}
              renderView={renderViewMessages}
            >
              <div className="relative max-h-max overflow-hidden pb-[30px] lg:max-h-[unset] lg:overflow-visible">
                {conversation?.messages.map((msg, index) => (
                  msg.sender === "other" ? (
                    <SingleMessage
                      key={index}
                      message={msg.message}
                      time={msg.time}
                      extra="!bg-lightPrimary w-fit rounded-r-xl rounded-bl-xl"
                      text="text-navy-700"
                      timecolor="text-gray-400 dark:text-white"
                    />
                  ) : (
                    <div key={index} className="flex flex-col items-end">
                      <SingleMessage
                        message={msg.message}
                        time={msg.time}
                        extra="bg-brand-500 w-fit md:w-[380px] rounded-l-xl rounded-br-xl"
                        text="text-white"
                        timecolor="text-white"
                      />
                    </div>
                  )
                ))}
              </div>
            </Scrollbars>
          </div>
          {/*  */}
          <div className="mt-6 flex items-center gap-2">
            <div className=" flex h-[50px] w-full items-center rounded-full bg-lightPrimary pr-3 dark:bg-navy-700">
              <input
                placeholder="Write your message...."
                className="h-full w-full rounded-full bg-lightPrimary px-4 text-sm text-navy-700 outline-none dark:bg-navy-700 dark:text-white"
                type="text"
              />
            </div>
            {/* button */}
            <button className="linear flex items-center justify-center rounded-full bg-brand-500 p-3 text-base text-white transition duration-200 hover:cursor-pointer  hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
              <IoPaperPlane />
            </button>
          </div>
        </div>
      </Card>
    </div>
  );
}

export default SingleChat;
